module.exports = __webpack_public_path__ + "static/media/thaikkudam.47822314.webp";